import { inject, Injectable } from '@angular/core';
import { catchError, firstValueFrom, map, of } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

import { ResponseMap } from '@core/domain/helpers';

@Injectable({
  providedIn: 'platform',
})
export class RecaptchaProviderService {
  private readonly recaptchaService = inject(ReCaptchaV3Service);

  async getRecaptcha(action: string) {
    return firstValueFrom(
      this.recaptchaService.execute(action).pipe(
        map((resp) =>
          ResponseMap.success({ 'x-action': action, 'x-recaptcha': resp }),
        ),
        catchError((err) => of(ResponseMap.failed(err))),
      ),
    );
  }
}
